var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"mt-0",attrs:{"hide-details":true,"color":"primary","label":""},model:{value:(_vm.isEnabled),callback:function ($$v) {_vm.isEnabled=$$v},expression:"isEnabled"}},[_vm._t("label",null,{"slot":"label"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }